export const IFP_VARS = {
  idTag:
    '29842f94d414949bf95fb2e6109142cfef1fb2a78114c2c536a36bf5a65b953a0c181ae122b9e5ff2fefe1439bbfc9cfab67738749fafb1d6077ca193590539a0260ef1a6e6ead8b409e94596d50076a360ae7266665313830f7b0090f4096e9fb1f9421eefdaaf57a719d8c674d5d65'
}

export const DICTIONARY_CONFIG = {
  serviceName: 'https://ws.walmeric.com/provision/wsVars/getVar.html?',
  idTag: `idTag=${IFP_VARS.idTag}`,
  dictionaryName: '&name=LANDINGS_IFP_ACTIONS'
}
